!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ImageGallery = t(require("react")) : e.ImageGallery = t(e.React);
}(this, e => (() => {
  var t = {
      703: (e, t, n) => {
        "use strict";

        var i = n(414);
        function r() {}
        function a() {}
        a.resetWarningCache = r, e.exports = function () {
          function e(e, t, n, r, a, o) {
            if (o !== i) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var n = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: a,
            resetWarningCache: r
          };
          return n.PropTypes = n, n;
        };
      },
      697: (e, t, n) => {
        e.exports = n(703)();
      },
      414: e => {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      590: e => {
        var t = "undefined" != typeof Element,
          n = "function" == typeof Map,
          i = "function" == typeof Set,
          r = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;
        function a(e, o) {
          if (e === o) return !0;
          if (e && o && "object" == typeof e && "object" == typeof o) {
            if (e.constructor !== o.constructor) return !1;
            var s, l, u, c;
            if (Array.isArray(e)) {
              if ((s = e.length) != o.length) return !1;
              for (l = s; 0 != l--;) if (!a(e[l], o[l])) return !1;
              return !0;
            }
            if (n && e instanceof Map && o instanceof Map) {
              if (e.size !== o.size) return !1;
              for (c = e.entries(); !(l = c.next()).done;) if (!o.has(l.value[0])) return !1;
              for (c = e.entries(); !(l = c.next()).done;) if (!a(l.value[1], o.get(l.value[0]))) return !1;
              return !0;
            }
            if (i && e instanceof Set && o instanceof Set) {
              if (e.size !== o.size) return !1;
              for (c = e.entries(); !(l = c.next()).done;) if (!o.has(l.value[0])) return !1;
              return !0;
            }
            if (r && ArrayBuffer.isView(e) && ArrayBuffer.isView(o)) {
              if ((s = e.length) != o.length) return !1;
              for (l = s; 0 != l--;) if (e[l] !== o[l]) return !1;
              return !0;
            }
            if (e.constructor === RegExp) return e.source === o.source && e.flags === o.flags;
            if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === o.valueOf();
            if (e.toString !== Object.prototype.toString) return e.toString() === o.toString();
            if ((s = (u = Object.keys(e)).length) !== Object.keys(o).length) return !1;
            for (l = s; 0 != l--;) if (!Object.prototype.hasOwnProperty.call(o, u[l])) return !1;
            if (t && e instanceof Element) return !1;
            for (l = s; 0 != l--;) if (("_owner" !== u[l] && "__v" !== u[l] && "__o" !== u[l] || !e.$$typeof) && !a(e[u[l]], o[u[l]])) return !1;
            return !0;
          }
          return e != e && o != o;
        }
        e.exports = function (e, t) {
          try {
            return a(e, t);
          } catch (e) {
            if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
            throw e;
          }
        };
      },
      359: t => {
        "use strict";

        t.exports = e;
      }
    },
    n = {};
  function i(e) {
    var r = n[e];
    if (void 0 !== r) return r.exports;
    var a = n[e] = {
      exports: {}
    };
    return t[e](a, a.exports, i), a.exports;
  }
  i.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return i.d(t, {
      a: t
    }), t;
  }, i.d = (e, t) => {
    for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, i.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), i.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  return (() => {
    "use strict";

    function e(t) {
      var n,
        i,
        r = "";
      if ("string" == typeof t || "number" == typeof t) r += t;else if ("object" == typeof t) if (Array.isArray(t)) for (n = 0; n < t.length; n++) t[n] && (i = e(t[n])) && (r && (r += " "), r += i);else for (n in t) t[n] && (r && (r += " "), r += n);
      return r;
    }
    function t() {
      for (var t, n, i = 0, r = ""; i < arguments.length;) (t = arguments[i++]) && (n = e(t)) && (r && (r += " "), r += n);
      return r;
    }
    i.r(r), i.d(r, {
      default: () => nt
    });
    var n = i(359),
      a = i.n(n);
    const o = function (e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      },
      s = "object" == typeof global && global && global.Object === Object && global;
    var l = "object" == typeof self && self && self.Object === Object && self;
    const u = s || l || Function("return this")(),
      c = function () {
        return u.Date.now();
      };
    var h = /\s/;
    var d = /^\s+/;
    const p = function (e) {
        return e ? e.slice(0, function (e) {
          for (var t = e.length; t-- && h.test(e.charAt(t)););
          return t;
        }(e) + 1).replace(d, "") : e;
      },
      f = u.Symbol;
    var m = Object.prototype,
      b = m.hasOwnProperty,
      g = m.toString,
      v = f ? f.toStringTag : void 0;
    var y = Object.prototype.toString;
    var w = f ? f.toStringTag : void 0;
    const S = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : w && w in Object(e) ? function (e) {
        var t = b.call(e, v),
          n = e[v];
        try {
          e[v] = void 0;
          var i = !0;
        } catch (e) {}
        var r = g.call(e);
        return i && (t ? e[v] = n : delete e[v]), r;
      }(e) : function (e) {
        return y.call(e);
      }(e);
    };
    var T = /^[-+]0x[0-9a-f]+$/i,
      O = /^0b[01]+$/i,
      E = /^0o[0-7]+$/i,
      k = parseInt;
    const I = function (e) {
      if ("number" == typeof e) return e;
      if (function (e) {
        return "symbol" == typeof e || function (e) {
          return null != e && "object" == typeof e;
        }(e) && "[object Symbol]" == S(e);
      }(e)) return NaN;
      if (o(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = o(t) ? t + "" : t;
      }
      if ("string" != typeof e) return 0 === e ? e : +e;
      e = p(e);
      var n = O.test(e);
      return n || E.test(e) ? k(e.slice(2), n ? 2 : 8) : T.test(e) ? NaN : +e;
    };
    var j = Math.max,
      x = Math.min;
    const P = function (e, t, n) {
        var i,
          r,
          a,
          s,
          l,
          u,
          h = 0,
          d = !1,
          p = !1,
          f = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        function m(t) {
          var n = i,
            a = r;
          return i = r = void 0, h = t, s = e.apply(a, n);
        }
        function b(e) {
          return h = e, l = setTimeout(v, t), d ? m(e) : s;
        }
        function g(e) {
          var n = e - u;
          return void 0 === u || n >= t || n < 0 || p && e - h >= a;
        }
        function v() {
          var e = c();
          if (g(e)) return y(e);
          l = setTimeout(v, function (e) {
            var n = t - (e - u);
            return p ? x(n, a - (e - h)) : n;
          }(e));
        }
        function y(e) {
          return l = void 0, f && i ? m(e) : (i = r = void 0, s);
        }
        function w() {
          var e = c(),
            n = g(e);
          if (i = arguments, r = this, u = e, n) {
            if (void 0 === l) return b(u);
            if (p) return clearTimeout(l), l = setTimeout(v, t), m(u);
          }
          return void 0 === l && (l = setTimeout(v, t)), s;
        }
        return t = I(t) || 0, o(n) && (d = !!n.leading, a = (p = "maxWait" in n) ? j(I(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), w.cancel = function () {
          void 0 !== l && clearTimeout(l), h = 0, i = u = r = l = void 0;
        }, w.flush = function () {
          return void 0 === l ? s : y(c());
        }, w;
      },
      _ = function (e, t, n) {
        var i = !0,
          r = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return o(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), P(e, t, {
          leading: i,
          maxWait: t,
          trailing: r
        });
      };
    var R = i(590),
      M = i.n(R),
      L = function () {
        if ("undefined" != typeof Map) return Map;
        function e(e, t) {
          var n = -1;
          return e.some(function (e, i) {
            return e[0] === t && (n = i, !0);
          }), n;
        }
        return function () {
          function t() {
            this.__entries__ = [];
          }
          return Object.defineProperty(t.prototype, "size", {
            get: function () {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.get = function (t) {
            var n = e(this.__entries__, t),
              i = this.__entries__[n];
            return i && i[1];
          }, t.prototype.set = function (t, n) {
            var i = e(this.__entries__, t);
            ~i ? this.__entries__[i][1] = n : this.__entries__.push([t, n]);
          }, t.prototype.delete = function (t) {
            var n = this.__entries__,
              i = e(n, t);
            ~i && n.splice(i, 1);
          }, t.prototype.has = function (t) {
            return !!~e(this.__entries__, t);
          }, t.prototype.clear = function () {
            this.__entries__.splice(0);
          }, t.prototype.forEach = function (e, t) {
            void 0 === t && (t = null);
            for (var n = 0, i = this.__entries__; n < i.length; n++) {
              var r = i[n];
              e.call(t, r[1], r[0]);
            }
          }, t;
        }();
      }(),
      D = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
      W = void 0 !== i.g && i.g.Math === Math ? i.g : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
      C = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(W) : function (e) {
        return setTimeout(function () {
          return e(Date.now());
        }, 1e3 / 60);
      },
      F = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
      z = "undefined" != typeof MutationObserver,
      N = function () {
        function e() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
            var n = !1,
              i = !1,
              r = 0;
            function a() {
              n && (n = !1, e()), i && s();
            }
            function o() {
              C(a);
            }
            function s() {
              var e = Date.now();
              if (n) {
                if (e - r < 2) return;
                i = !0;
              } else n = !0, i = !1, setTimeout(o, 20);
              r = e;
            }
            return s;
          }(this.refresh.bind(this));
        }
        return e.prototype.addObserver = function (e) {
          ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
        }, e.prototype.removeObserver = function (e) {
          var t = this.observers_,
            n = t.indexOf(e);
          ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
        }, e.prototype.refresh = function () {
          this.updateObservers_() && this.refresh();
        }, e.prototype.updateObservers_ = function () {
          var e = this.observers_.filter(function (e) {
            return e.gatherActive(), e.hasActive();
          });
          return e.forEach(function (e) {
            return e.broadcastActive();
          }), e.length > 0;
        }, e.prototype.connect_ = function () {
          D && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), z ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
            attributes: !0,
            childList: !0,
            characterData: !0,
            subtree: !0
          })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, e.prototype.disconnect_ = function () {
          D && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, e.prototype.onTransitionEnd_ = function (e) {
          var t = e.propertyName,
            n = void 0 === t ? "" : t;
          F.some(function (e) {
            return !!~n.indexOf(e);
          }) && this.refresh();
        }, e.getInstance = function () {
          return this.instance_ || (this.instance_ = new e()), this.instance_;
        }, e.instance_ = null, e;
      }(),
      B = function (e, t) {
        for (var n = 0, i = Object.keys(t); n < i.length; n++) {
          var r = i[n];
          Object.defineProperty(e, r, {
            value: t[r],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }
        return e;
      },
      A = function (e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView || W;
      },
      U = V(0, 0, 0, 0);
    function G(e) {
      return parseFloat(e) || 0;
    }
    function q(e) {
      for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      return t.reduce(function (t, n) {
        return t + G(e["border-" + n + "-width"]);
      }, 0);
    }
    var H = "undefined" != typeof SVGGraphicsElement ? function (e) {
      return e instanceof A(e).SVGGraphicsElement;
    } : function (e) {
      return e instanceof A(e).SVGElement && "function" == typeof e.getBBox;
    };
    function K(e) {
      return D ? H(e) ? function (e) {
        var t = e.getBBox();
        return V(0, 0, t.width, t.height);
      }(e) : function (e) {
        var t = e.clientWidth,
          n = e.clientHeight;
        if (!t && !n) return U;
        var i = A(e).getComputedStyle(e),
          r = function (e) {
            for (var t = {}, n = 0, i = ["top", "right", "bottom", "left"]; n < i.length; n++) {
              var r = i[n],
                a = e["padding-" + r];
              t[r] = G(a);
            }
            return t;
          }(i),
          a = r.left + r.right,
          o = r.top + r.bottom,
          s = G(i.width),
          l = G(i.height);
        if ("border-box" === i.boxSizing && (Math.round(s + a) !== t && (s -= q(i, "left", "right") + a), Math.round(l + o) !== n && (l -= q(i, "top", "bottom") + o)), !function (e) {
          return e === A(e).document.documentElement;
        }(e)) {
          var u = Math.round(s + a) - t,
            c = Math.round(l + o) - n;
          1 !== Math.abs(u) && (s -= u), 1 !== Math.abs(c) && (l -= c);
        }
        return V(r.left, r.top, s, l);
      }(e) : U;
    }
    function V(e, t, n, i) {
      return {
        x: e,
        y: t,
        width: n,
        height: i
      };
    }
    var X = function () {
        function e(e) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = V(0, 0, 0, 0), this.target = e;
        }
        return e.prototype.isActive = function () {
          var e = K(this.target);
          return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
        }, e.prototype.broadcastRect = function () {
          var e = this.contentRect_;
          return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
        }, e;
      }(),
      $ = function (e, t) {
        var n,
          i,
          r,
          a,
          o,
          s,
          l,
          u = (i = (n = t).x, r = n.y, a = n.width, o = n.height, s = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(s.prototype), B(l, {
            x: i,
            y: r,
            width: a,
            height: o,
            top: r,
            right: i + a,
            bottom: o + r,
            left: i
          }), l);
        B(this, {
          target: e,
          contentRect: u
        });
      },
      Y = function () {
        function e(e, t, n) {
          if (this.activeObservations_ = [], this.observations_ = new L(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n;
        }
        return e.prototype.observe = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof A(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) || (t.set(e, new X(e)), this.controller_.addObserver(this), this.controller_.refresh());
          }
        }, e.prototype.unobserve = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof A(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
          }
        }, e.prototype.disconnect = function () {
          this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, e.prototype.gatherActive = function () {
          var e = this;
          this.clearActive(), this.observations_.forEach(function (t) {
            t.isActive() && e.activeObservations_.push(t);
          });
        }, e.prototype.broadcastActive = function () {
          if (this.hasActive()) {
            var e = this.callbackCtx_,
              t = this.activeObservations_.map(function (e) {
                return new $(e.target, e.broadcastRect());
              });
            this.callback_.call(e, t, e), this.clearActive();
          }
        }, e.prototype.clearActive = function () {
          this.activeObservations_.splice(0);
        }, e.prototype.hasActive = function () {
          return this.activeObservations_.length > 0;
        }, e;
      }(),
      J = "undefined" != typeof WeakMap ? new WeakMap() : new L(),
      Q = function e(t) {
        if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = N.getInstance(),
          i = new Y(t, n, this);
        J.set(this, i);
      };
    ["observe", "unobserve", "disconnect"].forEach(function (e) {
      Q.prototype[e] = function () {
        var t;
        return (t = J.get(this))[e].apply(t, arguments);
      };
    });
    const Z = void 0 !== W.ResizeObserver ? W.ResizeObserver : Q,
      ee = "Left",
      te = "Right",
      ne = "Up",
      ie = "Down",
      re = {
        delta: 10,
        preventScrollOnSwipe: !1,
        rotationAngle: 0,
        trackMouse: !1,
        trackTouch: !0,
        swipeDuration: 1 / 0,
        touchEventOptions: {
          passive: !0
        }
      },
      ae = {
        first: !0,
        initial: [0, 0],
        start: 0,
        swiping: !1,
        xy: [0, 0]
      },
      oe = "mousemove",
      se = "mouseup";
    function le(e, t) {
      if (0 === t) return e;
      const n = Math.PI / 180 * t;
      return [e[0] * Math.cos(n) + e[1] * Math.sin(n), e[1] * Math.cos(n) - e[0] * Math.sin(n)];
    }
    function ue(e) {
      const {
          trackMouse: t
        } = e,
        i = n.useRef(Object.assign({}, ae)),
        r = n.useRef(Object.assign({}, re)),
        a = n.useRef(Object.assign({}, r.current));
      let o;
      for (o in a.current = Object.assign({}, r.current), r.current = Object.assign(Object.assign({}, re), e), re) void 0 === r.current[o] && (r.current[o] = re[o]);
      const [s, l] = n.useMemo(() => function (e, t) {
        const n = t => {
            const n = ("touches" in t);
            n && t.touches.length > 1 || e((e, r) => {
              r.trackMouse && !n && (document.addEventListener(oe, i), document.addEventListener(se, a));
              const {
                  clientX: o,
                  clientY: s
                } = n ? t.touches[0] : t,
                l = le([o, s], r.rotationAngle);
              return r.onTouchStartOrOnMouseDown && r.onTouchStartOrOnMouseDown({
                event: t
              }), Object.assign(Object.assign(Object.assign({}, e), ae), {
                initial: l.slice(),
                xy: l,
                start: t.timeStamp || 0
              });
            });
          },
          i = t => {
            e((e, n) => {
              const i = ("touches" in t);
              if (i && t.touches.length > 1) return e;
              if (t.timeStamp - e.start > n.swipeDuration) return e.swiping ? Object.assign(Object.assign({}, e), {
                swiping: !1
              }) : e;
              const {
                  clientX: r,
                  clientY: a
                } = i ? t.touches[0] : t,
                [o, s] = le([r, a], n.rotationAngle),
                l = o - e.xy[0],
                u = s - e.xy[1],
                c = Math.abs(l),
                h = Math.abs(u),
                d = (t.timeStamp || 0) - e.start,
                p = Math.sqrt(c * c + h * h) / (d || 1),
                f = [l / (d || 1), u / (d || 1)],
                m = function (e, t, n, i) {
                  return e > t ? n > 0 ? te : ee : i > 0 ? ie : ne;
                }(c, h, l, u),
                b = "number" == typeof n.delta ? n.delta : n.delta[m.toLowerCase()] || re.delta;
              if (c < b && h < b && !e.swiping) return e;
              const g = {
                absX: c,
                absY: h,
                deltaX: l,
                deltaY: u,
                dir: m,
                event: t,
                first: e.first,
                initial: e.initial,
                velocity: p,
                vxvy: f
              };
              g.first && n.onSwipeStart && n.onSwipeStart(g), n.onSwiping && n.onSwiping(g);
              let v = !1;
              return (n.onSwiping || n.onSwiped || n["onSwiped".concat(m)]) && (v = !0), v && n.preventScrollOnSwipe && n.trackTouch && t.cancelable && t.preventDefault(), Object.assign(Object.assign({}, e), {
                first: !1,
                eventData: g,
                swiping: !0
              });
            });
          },
          r = t => {
            e((e, n) => {
              let i;
              if (e.swiping && e.eventData) {
                if (t.timeStamp - e.start < n.swipeDuration) {
                  i = Object.assign(Object.assign({}, e.eventData), {
                    event: t
                  }), n.onSwiped && n.onSwiped(i);
                  const r = n["onSwiped".concat(i.dir)];
                  r && r(i);
                }
              } else n.onTap && n.onTap({
                event: t
              });
              return n.onTouchEndOrOnMouseUp && n.onTouchEndOrOnMouseUp({
                event: t
              }), Object.assign(Object.assign(Object.assign({}, e), ae), {
                eventData: i
              });
            });
          },
          a = e => {
            document.removeEventListener(oe, i), document.removeEventListener(se, a), r(e);
          },
          o = (e, t) => {
            let a = () => {};
            if (e && e.addEventListener) {
              const o = Object.assign(Object.assign({}, re.touchEventOptions), t.touchEventOptions),
                s = [["touchstart", n, o], ["touchmove", i, Object.assign(Object.assign({}, o), t.preventScrollOnSwipe ? {
                  passive: !1
                } : {})], ["touchend", r, o]];
              s.forEach(_ref => {
                let [t, n, i] = _ref;
                return e.addEventListener(t, n, i);
              }), a = () => s.forEach(_ref2 => {
                let [t, n] = _ref2;
                return e.removeEventListener(t, n);
              });
            }
            return a;
          },
          s = {
            ref: t => {
              null !== t && e((e, n) => {
                if (e.el === t) return e;
                const i = {};
                return e.el && e.el !== t && e.cleanUpTouch && (e.cleanUpTouch(), i.cleanUpTouch = void 0), n.trackTouch && t && (i.cleanUpTouch = o(t, n)), Object.assign(Object.assign(Object.assign({}, e), {
                  el: t
                }), i);
              });
            }
          };
        return t.trackMouse && (s.onMouseDown = n), [s, o];
      }(e => i.current = e(i.current, r.current), {
        trackMouse: t
      }), [t]);
      return i.current = function (e, t, n, i) {
        return t.trackTouch && e.el ? e.cleanUpTouch ? t.preventScrollOnSwipe !== n.preventScrollOnSwipe || t.touchEventOptions.passive !== n.touchEventOptions.passive ? (e.cleanUpTouch(), Object.assign(Object.assign({}, e), {
          cleanUpTouch: i(e.el, t)
        })) : e : Object.assign(Object.assign({}, e), {
          cleanUpTouch: i(e.el, t)
        }) : (e.cleanUpTouch && e.cleanUpTouch(), Object.assign(Object.assign({}, e), {
          cleanUpTouch: void 0
        }));
      }(i.current, r.current, a.current, l), s;
    }
    var ce = i(697);
    function he(e) {
      return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, he(e);
    }
    function de(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function pe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? de(Object(n), !0).forEach(function (t) {
          fe(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : de(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function fe(e, t, n) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" !== he(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var i = n.call(e, t);
            if ("object" !== he(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(e, "string");
        return "symbol" === he(t) ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var me = {
        description: "",
        fullscreen: "",
        isFullscreen: !1,
        originalAlt: "",
        originalHeight: "",
        originalWidth: "",
        originalTitle: "",
        sizes: "",
        srcSet: "",
        loading: "eager"
      },
      be = a().memo(function (e) {
        var t = pe(pe({}, me), e),
          n = t.description,
          i = t.fullscreen,
          r = t.handleImageLoaded,
          o = t.isFullscreen,
          s = t.onImageError,
          l = t.original,
          u = t.originalAlt,
          c = t.originalHeight,
          h = t.originalWidth,
          d = t.originalTitle,
          p = t.sizes,
          f = t.srcSet,
          m = t.loading,
          b = o && i || l;
        return a().createElement(a().Fragment, null, a().createElement("img", {
          className: "image-gallery-image",
          src: b,
          alt: u,
          srcSet: f,
          height: c,
          width: h,
          sizes: p,
          title: d,
          onLoad: function (e) {
            return r(e, l);
          },
          onError: s,
          loading: m
        }), n && a().createElement("span", {
          className: "image-gallery-description"
        }, n));
      });
    be.displayName = "Item", be.propTypes = {
      description: ce.string,
      fullscreen: ce.string,
      handleImageLoaded: ce.func.isRequired,
      isFullscreen: ce.bool,
      onImageError: ce.func.isRequired,
      original: ce.string.isRequired,
      originalAlt: ce.string,
      originalHeight: ce.string,
      originalWidth: ce.string,
      originalTitle: ce.string,
      sizes: ce.string,
      srcSet: ce.string,
      loading: ce.string
    };
    const ge = be;
    function ve(e) {
      return ve = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, ve(e);
    }
    function ye(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function we(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ye(Object(n), !0).forEach(function (t) {
          Se(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function Se(e, t, n) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" !== ve(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var i = n.call(e, t);
            if ("object" !== ve(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(e, "string");
        return "symbol" === ve(t) ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var Te = {
        left: a().createElement("polyline", {
          points: "15 18 9 12 15 6"
        }),
        right: a().createElement("polyline", {
          points: "9 18 15 12 9 6"
        }),
        maximize: a().createElement("path", {
          d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
        }),
        minimize: a().createElement("path", {
          d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
        }),
        play: a().createElement("polygon", {
          points: "5 3 19 12 5 21 5 3"
        }),
        pause: a().createElement(a().Fragment, null, a().createElement("rect", {
          x: "6",
          y: "4",
          width: "4",
          height: "16"
        }), a().createElement("rect", {
          x: "14",
          y: "4",
          width: "4",
          height: "16"
        }))
      },
      Oe = {
        strokeWidth: 1,
        viewBox: "0 0 24 24"
      },
      Ee = function (e) {
        var t = we(we({}, Oe), e),
          n = t.strokeWidth,
          i = t.viewBox,
          r = t.icon;
        return a().createElement("svg", {
          className: "image-gallery-svg",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: i,
          fill: "none",
          stroke: "currentColor",
          strokeWidth: n,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }, Te[r]);
      };
    Ee.propTypes = {
      strokeWidth: ce.number,
      viewBox: ce.string,
      icon: (0, ce.oneOf)(["left", "right", "maximize", "minimize", "play", "pause"]).isRequired
    };
    const ke = Ee;
    var Ie = a().memo(function (e) {
      var t = e.isFullscreen,
        n = e.onClick;
      return a().createElement("button", {
        type: "button",
        className: "image-gallery-icon image-gallery-fullscreen-button",
        onClick: n,
        "aria-label": "Open Fullscreen"
      }, a().createElement(ke, {
        strokeWidth: 2,
        icon: t ? "minimize" : "maximize"
      }));
    });
    Ie.displayName = "Fullscreen", Ie.propTypes = {
      isFullscreen: ce.bool.isRequired,
      onClick: ce.func.isRequired
    };
    const je = Ie;
    var xe = a().memo(function (e) {
      var t = e.disabled,
        n = e.onClick;
      return a().createElement("button", {
        type: "button",
        className: "image-gallery-icon image-gallery-left-nav",
        disabled: t,
        onClick: n,
        "aria-label": "Previous Slide"
      }, a().createElement(ke, {
        icon: "left",
        viewBox: "6 0 12 24"
      }));
    });
    xe.displayName = "LeftNav", xe.propTypes = {
      disabled: ce.bool.isRequired,
      onClick: ce.func.isRequired
    };
    const Pe = xe;
    var _e = a().memo(function (e) {
      var t = e.disabled,
        n = e.onClick;
      return a().createElement("button", {
        type: "button",
        className: "image-gallery-icon image-gallery-right-nav",
        disabled: t,
        onClick: n,
        "aria-label": "Next Slide"
      }, a().createElement(ke, {
        icon: "right",
        viewBox: "6 0 12 24"
      }));
    });
    _e.displayName = "RightNav", _e.propTypes = {
      disabled: ce.bool.isRequired,
      onClick: ce.func.isRequired
    };
    const Re = _e;
    var Me = a().memo(function (e) {
      var t = e.isPlaying,
        n = e.onClick;
      return a().createElement("button", {
        type: "button",
        className: "image-gallery-icon image-gallery-play-button",
        onClick: n,
        "aria-label": "Play or Pause Slideshow"
      }, a().createElement(ke, {
        strokeWidth: 2,
        icon: t ? "pause" : "play"
      }));
    });
    Me.displayName = "PlayPause", Me.propTypes = {
      isPlaying: ce.bool.isRequired,
      onClick: ce.func.isRequired
    };
    const Le = Me;
    function De(e) {
      return De = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, De(e);
    }
    function We() {
      return We = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
        }
        return e;
      }, We.apply(this, arguments);
    }
    function Ce(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function Fe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ce(Object(n), !0).forEach(function (t) {
          ze(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ce(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function ze(e, t, n) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" !== De(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var i = n.call(e, t);
            if ("object" !== De(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(e, "string");
        return "symbol" === De(t) ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var Ne = {
        className: "",
        delta: 0,
        onSwiping: function () {},
        onSwiped: function () {}
      },
      Be = function (e) {
        var t = Fe(Fe({}, Ne), e),
          n = t.children,
          i = t.className,
          r = ue({
            delta: t.delta,
            onSwiping: t.onSwiping,
            onSwiped: t.onSwiped
          });
        return a().createElement("div", We({}, r, {
          className: i
        }), n);
      };
    Be.propTypes = {
      children: ce.node.isRequired,
      className: ce.string,
      delta: ce.number,
      onSwiped: ce.func,
      onSwiping: ce.func
    };
    const Ae = Be;
    function Ue(e) {
      return Ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, Ue(e);
    }
    function Ge(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }
      return n;
    }
    function qe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ge(Object(n), !0).forEach(function (t) {
          Ye(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ge(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function He(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, Je(i.key), i);
      }
    }
    function Ke(e, t) {
      return Ke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, Ke(e, t);
    }
    function Ve(e, t) {
      if (t && ("object" === Ue(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Xe(e);
    }
    function Xe(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function $e(e) {
      return $e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, $e(e);
    }
    function Ye(e, t, n) {
      return (t = Je(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function Je(e) {
      var t = function (e, t) {
        if ("object" !== Ue(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var i = n.call(e, t);
          if ("object" !== Ue(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e, "string");
      return "symbol" === Ue(t) ? t : String(t);
    }
    var Qe = ["fullscreenchange", "MSFullscreenChange", "mozfullscreenchange", "webkitfullscreenchange"],
      Ze = (0, ce.arrayOf)((0, ce.shape)({
        srcSet: ce.string,
        media: ce.string
      }));
    function et(e) {
      var t = parseInt(e.keyCode || e.which || 0, 10);
      return 66 === t || 62 === t;
    }
    var tt = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ke(e, t);
      }(l, e);
      var n,
        i,
        r,
        o,
        s = (r = l, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
            t = $e(r);
          if (o) {
            var n = $e(this).constructor;
            e = Reflect.construct(t, arguments, n);
          } else e = t.apply(this, arguments);
          return Ve(this, e);
        });
      function l(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, l), Ye(Xe(t = s.call(this, e)), "onBulletClick", function (e, n) {
          var i = t.props,
            r = i.onBulletClick,
            a = i.items,
            o = t.state.currentIndex;
          e.target.blur(), o !== n && (2 === a.length ? t.slideToIndexWithStyleReset(n, e) : t.slideToIndex(n, e)), r && r(e, n);
        }), t.state = {
          currentIndex: e.startIndex,
          thumbsTranslate: 0,
          thumbsSwipedTranslate: 0,
          currentSlideOffset: 0,
          galleryWidth: 0,
          thumbnailsWrapperWidth: 0,
          thumbnailsWrapperHeight: 0,
          thumbsStyle: {
            transition: "all ".concat(e.slideDuration, "ms ease-out")
          },
          isFullscreen: !1,
          isSwipingThumbnail: !1,
          isPlaying: !1
        }, t.loadedImages = {}, t.imageGallery = a().createRef(), t.thumbnailsWrapper = a().createRef(), t.thumbnails = a().createRef(), t.imageGallerySlideWrapper = a().createRef(), t.handleImageLoaded = t.handleImageLoaded.bind(Xe(t)), t.handleKeyDown = t.handleKeyDown.bind(Xe(t)), t.handleMouseDown = t.handleMouseDown.bind(Xe(t)), t.handleResize = t.handleResize.bind(Xe(t)), t.handleTouchMove = t.handleTouchMove.bind(Xe(t)), t.handleOnSwiped = t.handleOnSwiped.bind(Xe(t)), t.handleScreenChange = t.handleScreenChange.bind(Xe(t)), t.handleSwiping = t.handleSwiping.bind(Xe(t)), t.handleThumbnailSwiping = t.handleThumbnailSwiping.bind(Xe(t)), t.handleOnThumbnailSwiped = t.handleOnThumbnailSwiped.bind(Xe(t)), t.onThumbnailMouseLeave = t.onThumbnailMouseLeave.bind(Xe(t)), t.handleImageError = t.handleImageError.bind(Xe(t)), t.pauseOrPlay = t.pauseOrPlay.bind(Xe(t)), t.renderThumbInner = t.renderThumbInner.bind(Xe(t)), t.renderItem = t.renderItem.bind(Xe(t)), t.slideLeft = t.slideLeft.bind(Xe(t)), t.slideRight = t.slideRight.bind(Xe(t)), t.toggleFullScreen = t.toggleFullScreen.bind(Xe(t)), t.togglePlay = t.togglePlay.bind(Xe(t)), t.unthrottledSlideToIndex = t.slideToIndex, t.slideToIndex = _(t.unthrottledSlideToIndex, e.slideDuration, {
          trailing: !1
        }), e.lazyLoad && (t.lazyLoaded = []), t;
      }
      return n = l, i = [{
        key: "componentDidMount",
        value: function () {
          var e = this.props,
            t = e.autoPlay,
            n = e.useWindowKeyDown;
          t && this.play(), n ? window.addEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.addEventListener("keydown", this.handleKeyDown), window.addEventListener("mousedown", this.handleMouseDown), window.addEventListener("touchmove", this.handleTouchMove, {
            passive: !1
          }), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), this.addScreenChangeEvent();
        }
      }, {
        key: "componentDidUpdate",
        value: function (e, t) {
          var n = this.props,
            i = n.items,
            r = n.lazyLoad,
            a = n.slideDuration,
            o = n.slideInterval,
            s = n.startIndex,
            l = n.thumbnailPosition,
            u = n.showThumbnails,
            c = n.useWindowKeyDown,
            h = this.state,
            d = h.currentIndex,
            p = h.isPlaying,
            f = e.items.length !== i.length,
            m = !M()(e.items, i),
            b = e.startIndex !== s,
            g = e.thumbnailPosition !== l,
            v = e.showThumbnails !== u;
          o === e.slideInterval && a === e.slideDuration || p && (this.pause(), this.play()), g && (this.removeResizeObserver(), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper)), v && u && this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), v && !u && this.removeThumbnailsResizeObserver(), (f || v) && this.handleResize(), t.currentIndex !== d && this.slideThumbnailBar(), e.slideDuration !== a && (this.slideToIndex = _(this.unthrottledSlideToIndex, a, {
            trailing: !1
          })), !r || e.lazyLoad && !m || (this.lazyLoaded = []), c !== e.useWindowKeyDown && (c ? (this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown), window.addEventListener("keydown", this.handleKeyDown)) : (window.removeEventListener("keydown", this.handleKeyDown), this.imageGallery.current.addEventListener("keydown", this.handleKeyDown))), (b || m) && this.setState({
            currentIndex: s,
            slideStyle: {
              transition: "none"
            }
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          var e = this.props.useWindowKeyDown;
          window.removeEventListener("mousedown", this.handleMouseDown), window.removeEventListener("touchmove", this.handleTouchMove), this.removeScreenChangeEvent(), this.removeResizeObserver(), this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null), this.transitionTimer && window.clearTimeout(this.transitionTimer), e ? window.removeEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown);
        }
      }, {
        key: "onSliding",
        value: function () {
          var e = this,
            t = this.state,
            n = t.currentIndex,
            i = t.isTransitioning,
            r = this.props,
            a = r.onSlide,
            o = r.slideDuration;
          this.transitionTimer = window.setTimeout(function () {
            i && (e.setState({
              isTransitioning: !i,
              isSwipingThumbnail: !1
            }), a && a(n));
          }, o + 50);
        }
      }, {
        key: "onThumbnailClick",
        value: function (e, t) {
          var n = this.props,
            i = n.onThumbnailClick,
            r = n.items,
            a = this.state.currentIndex;
          e.target.parentNode.parentNode.blur(), a !== t && (2 === r.length ? this.slideToIndexWithStyleReset(t, e) : this.slideToIndex(t, e)), i && i(e, t);
        }
      }, {
        key: "onThumbnailMouseOver",
        value: function (e, t) {
          var n = this;
          this.thumbnailMouseOverTimer && (window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null), this.thumbnailMouseOverTimer = window.setTimeout(function () {
            n.slideToIndex(t), n.pause();
          }, 300);
        }
      }, {
        key: "onThumbnailMouseLeave",
        value: function () {
          if (this.thumbnailMouseOverTimer) {
            var e = this.props.autoPlay;
            window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null, e && this.play();
          }
        }
      }, {
        key: "setThumbsTranslate",
        value: function (e) {
          this.setState({
            thumbsTranslate: e
          });
        }
      }, {
        key: "setModalFullscreen",
        value: function (e) {
          var t = this.props.onScreenChange;
          this.setState({
            modalFullscreen: e
          }), t && t(e);
        }
      }, {
        key: "getThumbsTranslate",
        value: function (e) {
          var t,
            n = this.props,
            i = n.disableThumbnailScroll,
            r = n.items,
            a = this.state,
            o = a.thumbnailsWrapperWidth,
            s = a.thumbnailsWrapperHeight,
            l = this.thumbnails && this.thumbnails.current;
          if (i) return 0;
          if (l) {
            if (this.isThumbnailVertical()) {
              if (l.scrollHeight <= s) return 0;
              t = l.scrollHeight - s;
            } else {
              if (l.scrollWidth <= o || o <= 0) return 0;
              t = l.scrollWidth - o;
            }
            return e * (t / (r.length - 1));
          }
          return 0;
        }
      }, {
        key: "getThumbnailPositionClassName",
        value: function (e) {
          switch (e) {
            case "left":
              e = " ".concat("image-gallery-thumbnails-left");
              break;
            case "right":
              e = " ".concat("image-gallery-thumbnails-right");
              break;
            case "bottom":
              e = " ".concat("image-gallery-thumbnails-bottom");
              break;
            case "top":
              e = " ".concat("image-gallery-thumbnails-top");
          }
          return e;
        }
      }, {
        key: "getAlignmentClassName",
        value: function (e) {
          var t = this.state.currentIndex,
            n = this.props,
            i = n.infinite,
            r = n.items,
            a = "",
            o = "image-gallery-left",
            s = "image-gallery-right";
          switch (e) {
            case t - 1:
              a = " ".concat(o);
              break;
            case t:
              a = " ".concat("image-gallery-center");
              break;
            case t + 1:
              a = " ".concat(s);
          }
          return r.length >= 3 && i && (0 === e && t === r.length - 1 ? a = " ".concat(s) : e === r.length - 1 && 0 === t && (a = " ".concat(o))), a;
        }
      }, {
        key: "getTranslateXForTwoSlide",
        value: function (e) {
          var t = this.state,
            n = t.currentIndex,
            i = t.currentSlideOffset,
            r = t.previousIndex,
            a = n !== r,
            o = 0 === e && 0 === r,
            s = 1 === e && 1 === r,
            l = 0 === e && 1 === n,
            u = 1 === e && 0 === n,
            c = 0 === i,
            h = -100 * n + 100 * e + i;
          return i > 0 ? this.direction = "left" : i < 0 && (this.direction = "right"), u && i > 0 && (h = -100 + i), l && i < 0 && (h = 100 + i), a ? o && c && "left" === this.direction ? h = 100 : s && c && "right" === this.direction && (h = -100) : (u && c && "left" === this.direction && (h = -100), l && c && "right" === this.direction && (h = 100)), h;
        }
      }, {
        key: "getThumbnailBarHeight",
        value: function () {
          return this.isThumbnailVertical() ? {
            height: this.state.gallerySlideWrapperHeight
          } : {};
        }
      }, {
        key: "getSlideStyle",
        value: function (e) {
          var t = this.state,
            n = t.currentIndex,
            i = t.currentSlideOffset,
            r = t.slideStyle,
            a = this.props,
            o = a.infinite,
            s = a.items,
            l = a.useTranslate3D,
            u = a.isRTL,
            c = -100 * n,
            h = s.length - 1,
            d = (c + 100 * e) * (u ? -1 : 1) + i;
          o && s.length > 2 && (0 === n && e === h ? d = -100 * (u ? -1 : 1) + i : n === h && 0 === e && (d = 100 * (u ? -1 : 1) + i)), o && 2 === s.length && (d = this.getTranslateXForTwoSlide(e));
          var p = "translate(".concat(d, "%, 0)");
          return l && (p = "translate3d(".concat(d, "%, 0, 0)")), qe({
            display: this.isSlideVisible(e) ? "inherit" : "none",
            WebkitTransform: p,
            MozTransform: p,
            msTransform: p,
            OTransform: p,
            transform: p
          }, r);
        }
      }, {
        key: "getCurrentIndex",
        value: function () {
          return this.state.currentIndex;
        }
      }, {
        key: "getThumbnailStyle",
        value: function () {
          var e,
            t = this.props,
            n = t.useTranslate3D,
            i = t.isRTL,
            r = this.state,
            a = r.thumbsTranslate,
            o = r.thumbsStyle,
            s = i ? -1 * a : a;
          return this.isThumbnailVertical() ? (e = "translate(0, ".concat(a, "px)"), n && (e = "translate3d(0, ".concat(a, "px, 0)"))) : (e = "translate(".concat(s, "px, 0)"), n && (e = "translate3d(".concat(s, "px, 0, 0)"))), qe({
            WebkitTransform: e,
            MozTransform: e,
            msTransform: e,
            OTransform: e,
            transform: e
          }, o);
        }
      }, {
        key: "getSlideItems",
        value: function () {
          var e = this,
            n = this.state.currentIndex,
            i = this.props,
            r = i.items,
            o = i.slideOnThumbnailOver,
            s = i.onClick,
            l = i.lazyLoad,
            u = i.onTouchMove,
            c = i.onTouchEnd,
            h = i.onTouchStart,
            d = i.onMouseOver,
            p = i.onMouseLeave,
            f = i.renderItem,
            m = i.renderThumbInner,
            b = i.showThumbnails,
            g = i.showBullets,
            v = [],
            y = [],
            w = [];
          return r.forEach(function (i, r) {
            var S = e.getAlignmentClassName(r),
              T = i.originalClass ? " ".concat(i.originalClass) : "",
              O = i.thumbnailClass ? " ".concat(i.thumbnailClass) : "",
              E = i.renderItem || f || e.renderItem,
              k = i.renderThumbInner || m || e.renderThumbInner,
              I = !l || S || e.lazyLoaded[r];
            I && l && !e.lazyLoaded[r] && (e.lazyLoaded[r] = !0);
            var j = e.getSlideStyle(r),
              x = a().createElement("div", {
                "aria-label": "Go to Slide ".concat(r + 1),
                key: "slide-".concat(r),
                tabIndex: "-1",
                className: "image-gallery-slide ".concat(S, " ").concat(T),
                style: j,
                onClick: s,
                onKeyUp: e.handleSlideKeyUp,
                onTouchMove: u,
                onTouchEnd: c,
                onTouchStart: h,
                onMouseOver: d,
                onFocus: d,
                onMouseLeave: p,
                role: "button"
              }, I ? E(i) : a().createElement("div", {
                style: {
                  height: "100%"
                }
              }));
            if (v.push(x), b && i.thumbnail) {
              var P = t("image-gallery-thumbnail", O, {
                active: n === r
              });
              y.push(a().createElement("button", {
                key: "thumbnail-".concat(r),
                type: "button",
                tabIndex: "0",
                "aria-pressed": n === r ? "true" : "false",
                "aria-label": "Go to Slide ".concat(r + 1),
                className: P,
                onMouseLeave: o ? e.onThumbnailMouseLeave : null,
                onMouseOver: function (t) {
                  return e.handleThumbnailMouseOver(t, r);
                },
                onFocus: function (t) {
                  return e.handleThumbnailMouseOver(t, r);
                },
                onKeyUp: function (t) {
                  return e.handleThumbnailKeyUp(t, r);
                },
                onClick: function (t) {
                  return e.onThumbnailClick(t, r);
                }
              }, k(i)));
            }
            if (g) {
              var _ = t("image-gallery-bullet", i.bulletClass, {
                active: n === r
              });
              w.push(a().createElement("button", {
                type: "button",
                key: "bullet-".concat(r),
                className: _,
                onClick: function (t) {
                  return e.onBulletClick(t, r);
                },
                "aria-pressed": n === r ? "true" : "false",
                "aria-label": "Go to Slide ".concat(r + 1)
              }));
            }
          }), {
            slides: v,
            thumbnails: y,
            bullets: w
          };
        }
      }, {
        key: "ignoreIsTransitioning",
        value: function () {
          var e = this.props.items,
            t = this.state,
            n = t.previousIndex,
            i = t.currentIndex,
            r = e.length - 1;
          return Math.abs(n - i) > 1 && !(0 === n && i === r) && !(n === r && 0 === i);
        }
      }, {
        key: "isFirstOrLastSlide",
        value: function (e) {
          return e === this.props.items.length - 1 || 0 === e;
        }
      }, {
        key: "slideIsTransitioning",
        value: function (e) {
          var t = this.state,
            n = t.isTransitioning,
            i = t.previousIndex,
            r = t.currentIndex;
          return n && !(e === i || e === r);
        }
      }, {
        key: "isSlideVisible",
        value: function (e) {
          return !this.slideIsTransitioning(e) || this.ignoreIsTransitioning() && !this.isFirstOrLastSlide(e);
        }
      }, {
        key: "slideThumbnailBar",
        value: function () {
          var e = this.state,
            t = e.currentIndex,
            n = e.isSwipingThumbnail,
            i = -this.getThumbsTranslate(t);
          n || (0 === t ? this.setState({
            thumbsTranslate: 0,
            thumbsSwipedTranslate: 0
          }) : this.setState({
            thumbsTranslate: i,
            thumbsSwipedTranslate: i
          }));
        }
      }, {
        key: "canSlide",
        value: function () {
          return this.props.items.length >= 2;
        }
      }, {
        key: "canSlideLeft",
        value: function () {
          return this.props.infinite || this.canSlidePrevious();
        }
      }, {
        key: "canSlideRight",
        value: function () {
          return this.props.infinite || this.canSlideNext();
        }
      }, {
        key: "canSlidePrevious",
        value: function () {
          return this.state.currentIndex > 0;
        }
      }, {
        key: "canSlideNext",
        value: function () {
          return this.state.currentIndex < this.props.items.length - 1;
        }
      }, {
        key: "handleSwiping",
        value: function (e) {
          var t = e.event,
            n = e.absX,
            i = e.dir,
            r = this.props,
            a = r.disableSwipe,
            o = r.stopPropagation,
            s = this.state,
            l = s.galleryWidth,
            u = s.isTransitioning,
            c = s.swipingUpDown,
            h = s.swipingLeftRight;
          if (i !== ne && i !== ie && !c || h) {
            if (i !== ee && i !== te || h || this.setState({
              swipingLeftRight: !0
            }), !a) {
              var d = this.props.swipingTransitionDuration;
              if (o && t.preventDefault(), u) this.setState({
                currentSlideOffset: 0
              });else {
                var p = i === te ? 1 : -1,
                  f = n / l * 100;
                Math.abs(f) >= 100 && (f = 100);
                var m = {
                  transition: "transform ".concat(d, "ms ease-out")
                };
                this.setState({
                  currentSlideOffset: p * f,
                  slideStyle: m
                });
              }
            }
          } else c || this.setState({
            swipingUpDown: !0
          });
        }
      }, {
        key: "handleThumbnailSwiping",
        value: function (e) {
          var t = e.event,
            n = e.absX,
            i = e.absY,
            r = e.dir,
            a = this.props,
            o = a.stopPropagation,
            s = a.swipingThumbnailTransitionDuration,
            l = this.state,
            u = l.thumbsSwipedTranslate,
            c = l.thumbnailsWrapperHeight,
            h = l.thumbnailsWrapperWidth,
            d = l.swipingUpDown,
            p = l.swipingLeftRight;
          if (this.isThumbnailVertical()) {
            if ((r === ee || r === te || p) && !d) return void (p || this.setState({
              swipingLeftRight: !0
            }));
            r !== ne && r !== ie || d || this.setState({
              swipingUpDown: !0
            });
          } else {
            if ((r === ne || r === ie || d) && !p) return void (d || this.setState({
              swipingUpDown: !0
            }));
            r !== ee && r !== te || p || this.setState({
              swipingLeftRight: !0
            });
          }
          var f,
            m,
            b,
            g,
            v,
            y = this.thumbnails && this.thumbnails.current;
          if (this.isThumbnailVertical() ? (f = u + (r === ie ? i : -i), m = y.scrollHeight - c + 20, b = Math.abs(f) > m, g = f > 20, v = y.scrollHeight <= c) : (f = u + (r === te ? n : -n), m = y.scrollWidth - h + 20, b = Math.abs(f) > m, g = f > 20, v = y.scrollWidth <= h), !v && (r !== ee && r !== ne || !b) && (r !== te && r !== ie || !g)) {
            o && t.stopPropagation();
            var w = {
              transition: "transform ".concat(s, "ms ease-out")
            };
            this.setState({
              thumbsTranslate: f,
              thumbsStyle: w
            });
          }
        }
      }, {
        key: "handleOnThumbnailSwiped",
        value: function () {
          var e = this.state.thumbsTranslate,
            t = this.props.slideDuration;
          this.resetSwipingDirection(), this.setState({
            isSwipingThumbnail: !0,
            thumbsSwipedTranslate: e,
            thumbsStyle: {
              transition: "all ".concat(t, "ms ease-out")
            }
          });
        }
      }, {
        key: "sufficientSwipe",
        value: function () {
          var e = this.state.currentSlideOffset,
            t = this.props.swipeThreshold;
          return Math.abs(e) > t;
        }
      }, {
        key: "resetSwipingDirection",
        value: function () {
          var e = this.state,
            t = e.swipingUpDown,
            n = e.swipingLeftRight;
          t && this.setState({
            swipingUpDown: !1
          }), n && this.setState({
            swipingLeftRight: !1
          });
        }
      }, {
        key: "handleOnSwiped",
        value: function (e) {
          var t = e.event,
            n = e.dir,
            i = e.velocity,
            r = this.props,
            a = r.disableSwipe,
            o = r.stopPropagation,
            s = r.flickThreshold;
          if (!a) {
            var l = this.props.isRTL;
            o && t.stopPropagation(), this.resetSwipingDirection();
            var u = (n === ee ? 1 : -1) * (l ? -1 : 1),
              c = i > s && !(n === ne || n === ie);
            this.handleOnSwipedTo(u, c);
          }
        }
      }, {
        key: "handleOnSwipedTo",
        value: function (e, t) {
          var n = this.state,
            i = n.currentIndex,
            r = n.isTransitioning,
            a = i;
          !this.sufficientSwipe() && !t || r || (a += e), (-1 === e && !this.canSlideLeft() || 1 === e && !this.canSlideRight()) && (a = i), this.unthrottledSlideToIndex(a);
        }
      }, {
        key: "handleTouchMove",
        value: function (e) {
          this.state.swipingLeftRight && e.preventDefault();
        }
      }, {
        key: "handleMouseDown",
        value: function () {
          this.imageGallery.current.classList.add("image-gallery-using-mouse");
        }
      }, {
        key: "handleKeyDown",
        value: function (e) {
          var t = this.props,
            n = t.disableKeyDown,
            i = t.useBrowserFullscreen,
            r = this.state.isFullscreen;
          if (this.imageGallery.current.classList.remove("image-gallery-using-mouse"), !n) switch (parseInt(e.keyCode || e.which || 0, 10)) {
            case 37:
              this.canSlideLeft() && !this.playPauseIntervalId && this.slideLeft(e);
              break;
            case 39:
              this.canSlideRight() && !this.playPauseIntervalId && this.slideRight(e);
              break;
            case 27:
              r && !i && this.exitFullScreen();
          }
        }
      }, {
        key: "handleImageError",
        value: function (e) {
          var t = this.props.onErrorImageURL;
          t && -1 === e.target.src.indexOf(t) && (e.target.src = t);
        }
      }, {
        key: "removeThumbnailsResizeObserver",
        value: function () {
          this.resizeThumbnailWrapperObserver && this.thumbnailsWrapper && this.thumbnailsWrapper.current && (this.resizeThumbnailWrapperObserver.unobserve(this.thumbnailsWrapper.current), this.resizeThumbnailWrapperObserver = null);
        }
      }, {
        key: "removeResizeObserver",
        value: function () {
          this.resizeSlideWrapperObserver && this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && (this.resizeSlideWrapperObserver.unobserve(this.imageGallerySlideWrapper.current), this.resizeSlideWrapperObserver = null), this.removeThumbnailsResizeObserver();
        }
      }, {
        key: "handleResize",
        value: function () {
          var e = this.state.currentIndex;
          this.imageGallery && (this.imageGallery && this.imageGallery.current && this.setState({
            galleryWidth: this.imageGallery.current.offsetWidth
          }), this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && this.setState({
            gallerySlideWrapperHeight: this.imageGallerySlideWrapper.current.offsetHeight
          }), this.setThumbsTranslate(-this.getThumbsTranslate(e)));
        }
      }, {
        key: "initSlideWrapperResizeObserver",
        value: function (e) {
          var t = this;
          e && !e.current || (this.resizeSlideWrapperObserver = new Z(P(function (e) {
            e && e.forEach(function (e) {
              t.setState({
                thumbnailsWrapperWidth: e.contentRect.width
              }, t.handleResize);
            });
          }, 50)), this.resizeSlideWrapperObserver.observe(e.current));
        }
      }, {
        key: "initThumbnailWrapperResizeObserver",
        value: function (e) {
          var t = this;
          e && !e.current || (this.resizeThumbnailWrapperObserver = new Z(P(function (e) {
            e && e.forEach(function (e) {
              t.setState({
                thumbnailsWrapperHeight: e.contentRect.height
              }, t.handleResize);
            });
          }, 50)), this.resizeThumbnailWrapperObserver.observe(e.current));
        }
      }, {
        key: "toggleFullScreen",
        value: function () {
          this.state.isFullscreen ? this.exitFullScreen() : this.fullScreen();
        }
      }, {
        key: "togglePlay",
        value: function () {
          this.playPauseIntervalId ? this.pause() : this.play();
        }
      }, {
        key: "handleScreenChange",
        value: function () {
          var e = this.props,
            t = e.onScreenChange,
            n = e.useBrowserFullscreen,
            i = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement,
            r = this.imageGallery.current === i;
          t && t(r), n && this.setState({
            isFullscreen: r
          });
        }
      }, {
        key: "slideToIndex",
        value: function (e, t) {
          var n = this.state,
            i = n.currentIndex,
            r = n.isTransitioning,
            a = this.props,
            o = a.items,
            s = a.slideDuration,
            l = a.onBeforeSlide;
          if (!r) {
            t && this.playPauseIntervalId && (this.pause(!1), this.play(!1));
            var u = o.length - 1,
              c = e;
            e < 0 ? c = u : e > u && (c = 0), l && c !== i && l(c), this.setState({
              previousIndex: i,
              currentIndex: c,
              isTransitioning: c !== i,
              currentSlideOffset: 0,
              slideStyle: {
                transition: "all ".concat(s, "ms ease-out")
              }
            }, this.onSliding);
          }
        }
      }, {
        key: "slideLeft",
        value: function (e) {
          var t = this.props.isRTL;
          this.slideTo(e, t ? "right" : "left");
        }
      }, {
        key: "slideRight",
        value: function (e) {
          var t = this.props.isRTL;
          this.slideTo(e, t ? "left" : "right");
        }
      }, {
        key: "slideTo",
        value: function (e, t) {
          var n = this.state,
            i = n.currentIndex,
            r = n.isTransitioning,
            a = this.props.items,
            o = i + ("left" === t ? -1 : 1);
          r || (2 === a.length ? this.slideToIndexWithStyleReset(o, e) : this.slideToIndex(o, e));
        }
      }, {
        key: "slideToIndexWithStyleReset",
        value: function (e, t) {
          var n = this,
            i = this.state,
            r = i.currentIndex,
            a = i.currentSlideOffset;
          this.setState({
            currentSlideOffset: a + (r > e ? .001 : -.001),
            slideStyle: {
              transition: "none"
            }
          }, function () {
            window.setTimeout(function () {
              return n.slideToIndex(e, t);
            }, 25);
          });
        }
      }, {
        key: "handleThumbnailMouseOver",
        value: function (e, t) {
          this.props.slideOnThumbnailOver && this.onThumbnailMouseOver(e, t);
        }
      }, {
        key: "handleThumbnailKeyUp",
        value: function (e, t) {
          et(e) && this.onThumbnailClick(e, t);
        }
      }, {
        key: "handleSlideKeyUp",
        value: function (e) {
          et(e) && (0, this.props.onClick)(e);
        }
      }, {
        key: "isThumbnailVertical",
        value: function () {
          var e = this.props.thumbnailPosition;
          return "left" === e || "right" === e;
        }
      }, {
        key: "addScreenChangeEvent",
        value: function () {
          var e = this;
          Qe.forEach(function (t) {
            document.addEventListener(t, e.handleScreenChange);
          });
        }
      }, {
        key: "removeScreenChangeEvent",
        value: function () {
          var e = this;
          Qe.forEach(function (t) {
            document.removeEventListener(t, e.handleScreenChange);
          });
        }
      }, {
        key: "fullScreen",
        value: function () {
          var e = this.props.useBrowserFullscreen,
            t = this.imageGallery.current;
          e ? t.requestFullscreen ? t.requestFullscreen() : t.msRequestFullscreen ? t.msRequestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : this.setModalFullscreen(!0) : this.setModalFullscreen(!0), this.setState({
            isFullscreen: !0
          });
        }
      }, {
        key: "exitFullScreen",
        value: function () {
          var e = this.state.isFullscreen,
            t = this.props.useBrowserFullscreen;
          e && (t ? document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : this.setModalFullscreen(!1) : this.setModalFullscreen(!1), this.setState({
            isFullscreen: !1
          }));
        }
      }, {
        key: "pauseOrPlay",
        value: function () {
          var e = this.props.infinite,
            t = this.state.currentIndex;
          e || this.canSlideRight() ? this.slideToIndex(t + 1) : this.pause();
        }
      }, {
        key: "play",
        value: function () {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            t = this.props,
            n = t.onPlay,
            i = t.slideInterval,
            r = t.slideDuration,
            a = this.state.currentIndex;
          this.playPauseIntervalId || (this.setState({
            isPlaying: !0
          }), this.playPauseIntervalId = window.setInterval(this.pauseOrPlay, Math.max(i, r)), n && e && n(a));
        }
      }, {
        key: "pause",
        value: function () {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            t = this.props.onPause,
            n = this.state.currentIndex;
          this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null, this.setState({
            isPlaying: !1
          }), t && e && t(n));
        }
      }, {
        key: "isImageLoaded",
        value: function (e) {
          return !!this.loadedImages[e.original] || (this.loadedImages[e.original] = !0, !1);
        }
      }, {
        key: "handleImageLoaded",
        value: function (e, t) {
          var n = this.props.onImageLoad;
          !this.loadedImages[t] && n && (this.loadedImages[t] = !0, n(e));
        }
      }, {
        key: "renderItem",
        value: function (e) {
          var t = this.state.isFullscreen,
            n = this.props.onImageError || this.handleImageError;
          return a().createElement(ge, {
            description: e.description,
            fullscreen: e.fullscreen,
            handleImageLoaded: this.handleImageLoaded,
            isFullscreen: t,
            onImageError: n,
            original: e.original,
            originalAlt: e.originalAlt,
            originalHeight: e.originalHeight,
            originalWidth: e.originalWidth,
            originalTitle: e.originalTitle,
            sizes: e.sizes,
            loading: e.loading,
            srcSet: e.srcSet
          });
        }
      }, {
        key: "renderThumbInner",
        value: function (e) {
          var t = this.props.onThumbnailError || this.handleImageError;
          return a().createElement("span", {
            className: "image-gallery-thumbnail-inner"
          }, a().createElement("img", {
            className: "image-gallery-thumbnail-image",
            src: e.thumbnail,
            height: e.thumbnailHeight,
            width: e.thumbnailWidth,
            alt: e.thumbnailAlt,
            title: e.thumbnailTitle,
            loading: e.thumbnailLoading,
            onError: t
          }), e.thumbnailLabel && a().createElement("div", {
            className: "image-gallery-thumbnail-label"
          }, e.thumbnailLabel));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.state,
            n = e.currentIndex,
            i = e.isFullscreen,
            r = e.modalFullscreen,
            o = e.isPlaying,
            s = this.props,
            l = s.additionalClass,
            u = s.disableThumbnailSwipe,
            c = s.indexSeparator,
            h = s.isRTL,
            d = s.items,
            p = s.thumbnailPosition,
            f = s.renderFullscreenButton,
            m = s.renderCustomControls,
            b = s.renderLeftNav,
            g = s.renderRightNav,
            v = s.showBullets,
            y = s.showFullscreenButton,
            w = s.showIndex,
            S = s.showThumbnails,
            T = s.showNav,
            O = s.showPlayButton,
            E = s.renderPlayPauseButton,
            k = this.getThumbnailStyle(),
            I = this.getSlideItems(),
            j = I.slides,
            x = I.thumbnails,
            P = I.bullets,
            _ = t("image-gallery-slide-wrapper", this.getThumbnailPositionClassName(p), {
              "image-gallery-rtl": h
            }),
            R = a().createElement("div", {
              ref: this.imageGallerySlideWrapper,
              className: _
            }, m && m(), this.canSlide() ? a().createElement(a().Fragment, null, T && a().createElement(a().Fragment, null, b(this.slideLeft, !this.canSlideLeft()), g(this.slideRight, !this.canSlideRight())), a().createElement(Ae, {
              className: "image-gallery-swipe",
              delta: 0,
              onSwiping: this.handleSwiping,
              onSwiped: this.handleOnSwiped
            }, a().createElement("div", {
              className: "image-gallery-slides"
            }, j))) : a().createElement("div", {
              className: "image-gallery-slides"
            }, j), O && E(this.togglePlay, o), v && a().createElement("div", {
              className: "image-gallery-bullets"
            }, a().createElement("div", {
              className: "image-gallery-bullets-container",
              role: "navigation",
              "aria-label": "Bullet Navigation"
            }, P)), y && f(this.toggleFullScreen, i), w && a().createElement("div", {
              className: "image-gallery-index"
            }, a().createElement("span", {
              className: "image-gallery-index-current"
            }, n + 1), a().createElement("span", {
              className: "image-gallery-index-separator"
            }, c), a().createElement("span", {
              className: "image-gallery-index-total"
            }, d.length))),
            M = t("image-gallery", l, {
              "fullscreen-modal": r
            }),
            L = t("image-gallery-content", this.getThumbnailPositionClassName(p), {
              fullscreen: i
            }),
            D = t("image-gallery-thumbnails-wrapper", this.getThumbnailPositionClassName(p), {
              "thumbnails-wrapper-rtl": !this.isThumbnailVertical() && h
            }, {
              "thumbnails-swipe-horizontal": !this.isThumbnailVertical() && !u
            }, {
              "thumbnails-swipe-vertical": this.isThumbnailVertical() && !u
            });
          return a().createElement("div", {
            ref: this.imageGallery,
            className: M,
            "aria-live": "polite"
          }, a().createElement("div", {
            className: L
          }, ("bottom" === p || "right" === p) && R, S && x.length > 0 ? a().createElement(Ae, {
            className: D,
            delta: 0,
            onSwiping: !u && this.handleThumbnailSwiping,
            onSwiped: !u && this.handleOnThumbnailSwiped
          }, a().createElement("div", {
            className: "image-gallery-thumbnails",
            ref: this.thumbnailsWrapper,
            style: this.getThumbnailBarHeight()
          }, a().createElement("nav", {
            ref: this.thumbnails,
            className: "image-gallery-thumbnails-container",
            style: k,
            "aria-label": "Thumbnail Navigation"
          }, x))) : null, ("top" === p || "left" === p) && R));
        }
      }], i && He(n.prototype, i), Object.defineProperty(n, "prototype", {
        writable: !1
      }), l;
    }(a().Component);
    tt.propTypes = {
      flickThreshold: ce.number,
      items: (0, ce.arrayOf)((0, ce.shape)({
        bulletClass: ce.string,
        bulletOnClick: ce.func,
        description: ce.string,
        original: ce.string,
        originalHeight: ce.number,
        originalWidth: ce.number,
        loading: ce.string,
        thumbnailHeight: ce.number,
        thumbnailWidth: ce.number,
        thumbnailLoading: ce.string,
        fullscreen: ce.string,
        originalAlt: ce.string,
        originalTitle: ce.string,
        thumbnail: ce.string,
        thumbnailAlt: ce.string,
        thumbnailLabel: ce.string,
        thumbnailTitle: ce.string,
        originalClass: ce.string,
        thumbnailClass: ce.string,
        renderItem: ce.func,
        renderThumbInner: ce.func,
        imageSet: Ze,
        srcSet: ce.string,
        sizes: ce.string
      })).isRequired,
      showNav: ce.bool,
      autoPlay: ce.bool,
      lazyLoad: ce.bool,
      infinite: ce.bool,
      showIndex: ce.bool,
      showBullets: ce.bool,
      showThumbnails: ce.bool,
      showPlayButton: ce.bool,
      showFullscreenButton: ce.bool,
      disableThumbnailScroll: ce.bool,
      disableKeyDown: ce.bool,
      disableSwipe: ce.bool,
      disableThumbnailSwipe: ce.bool,
      useBrowserFullscreen: ce.bool,
      onErrorImageURL: ce.string,
      indexSeparator: ce.string,
      thumbnailPosition: (0, ce.oneOf)(["top", "bottom", "left", "right"]),
      startIndex: ce.number,
      slideDuration: ce.number,
      slideInterval: ce.number,
      slideOnThumbnailOver: ce.bool,
      swipeThreshold: ce.number,
      swipingTransitionDuration: ce.number,
      swipingThumbnailTransitionDuration: ce.number,
      onSlide: ce.func,
      onBeforeSlide: ce.func,
      onScreenChange: ce.func,
      onPause: ce.func,
      onPlay: ce.func,
      onClick: ce.func,
      onImageLoad: ce.func,
      onImageError: ce.func,
      onTouchMove: ce.func,
      onTouchEnd: ce.func,
      onTouchStart: ce.func,
      onMouseOver: ce.func,
      onMouseLeave: ce.func,
      onBulletClick: ce.func,
      onThumbnailError: ce.func,
      onThumbnailClick: ce.func,
      renderCustomControls: ce.func,
      renderLeftNav: ce.func,
      renderRightNav: ce.func,
      renderPlayPauseButton: ce.func,
      renderFullscreenButton: ce.func,
      renderItem: ce.func,
      renderThumbInner: ce.func,
      stopPropagation: ce.bool,
      additionalClass: ce.string,
      useTranslate3D: ce.bool,
      isRTL: ce.bool,
      useWindowKeyDown: ce.bool
    }, tt.defaultProps = {
      onErrorImageURL: "",
      additionalClass: "",
      showNav: !0,
      autoPlay: !1,
      lazyLoad: !1,
      infinite: !0,
      showIndex: !1,
      showBullets: !1,
      showThumbnails: !0,
      showPlayButton: !0,
      showFullscreenButton: !0,
      disableThumbnailScroll: !1,
      disableKeyDown: !1,
      disableSwipe: !1,
      disableThumbnailSwipe: !1,
      useTranslate3D: !0,
      isRTL: !1,
      useBrowserFullscreen: !0,
      flickThreshold: .4,
      stopPropagation: !1,
      indexSeparator: " / ",
      thumbnailPosition: "bottom",
      startIndex: 0,
      slideDuration: 450,
      swipingTransitionDuration: 0,
      swipingThumbnailTransitionDuration: 0,
      onSlide: null,
      onBeforeSlide: null,
      onScreenChange: null,
      onPause: null,
      onPlay: null,
      onClick: null,
      onImageLoad: null,
      onImageError: null,
      onTouchMove: null,
      onTouchEnd: null,
      onTouchStart: null,
      onMouseOver: null,
      onMouseLeave: null,
      onBulletClick: null,
      onThumbnailError: null,
      onThumbnailClick: null,
      renderCustomControls: null,
      renderThumbInner: null,
      renderItem: null,
      slideInterval: 3e3,
      slideOnThumbnailOver: !1,
      swipeThreshold: 30,
      renderLeftNav: function (e, t) {
        return a().createElement(Pe, {
          onClick: e,
          disabled: t
        });
      },
      renderRightNav: function (e, t) {
        return a().createElement(Re, {
          onClick: e,
          disabled: t
        });
      },
      renderPlayPauseButton: function (e, t) {
        return a().createElement(Le, {
          onClick: e,
          isPlaying: t
        });
      },
      renderFullscreenButton: function (e, t) {
        return a().createElement(je, {
          onClick: e,
          isFullscreen: t
        });
      },
      useWindowKeyDown: !0
    };
    const nt = tt;
  })(), r;
})());